<div [ngClass]="allAccess && loggedUserRole == 4 ?  'filtersContainerOutlet' : 'filtersContainer'">
    <div class="col-md-2 filter-btn" appShowHide style="display: contents;">
        <button type="button" class="btn-filter" data-toggle="collapse" data-target="#filterCollapsePOS"
            aria-expanded="false" aria-controls="collapseExample" (click)="refreshFilters()">
            <img src="../../../../../assets/icons/filter.png" id="navitem" width="16px" height="16px" alt=""
                loading="lazy" style="margin: 0px 5px ;">
            Filters
        </button>
    </div>

    <div class="col-md-10" style="display: flex; justify-content: flex-end;" appCanAccess [accessPolicy]="[12]">
        <div (click)="addPOSClick()" data-toggle="modal" data-target="#posModal" style="display: flex; justify-content: center; align-items: center; color: white; height: 42px; width: 182px; background-color: #2D5697; 
            border-radius: 5px; text-align: center; cursor: pointer;   font-weight: 400; font-size: 14px !important;">
            Add POS
        </div>
    </div>

</div>

<div class="collapse" id="filterCollapsePOS">

    <div class="filterCol">
        <form [formGroup]="filterForm" id="filterForm">
            <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'filtersBox' : 'filtersBoxAdmin' ">
                <label class="filterLbl" for="menuName">Admin Filters</label>
                <div class="row filtersRow">
                    <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'superAdmin' : 'admin' ">
                        <label class="lblInput" for="menuName">Franchise</label>
                        <div class="filterInput">
                            <select class='form-control bulkInput selectpicker' id="spicker_franchise_pos"
                                (ngModelChange)="selectFilterFranchise($event)" formControlName="franchise_pos"
                                data-style="dropdownCustomStyle">
                                <option selected value='' disabled
                                    data-content="<span class='text-secondary'>Nothing Selected</span>"></option>
                                <option *ngFor="let franchise of franchises" [ngValue]="franchise.id">
                                    {{franchise.name}} </option>
                            </select>
                        </div>
                    </div>
                    <div>
                        <label class="lblInput" for="menuName">Outlet</label>
                        <div class="filterInput2">
                            <select class='form-control bulkInput selectpicker' id="spicker_shop_pos"
                                formControlName="shop_pos" (ngModelChange)="selectFilterShop($event)"
                                data-style="dropdownCustomStyle" disabled>
                                <option selected value='' disabled
                                    data-content="<span class='text-secondary'>Nothing Selected</span>"></option>
                                <option *ngFor="let shop of shopsFilter" [ngValue]="shop">
                                    {{shop.name}} </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<div *ngIf="!isDataLoadedUser" class="item">
    <ngx-skeleton-loader class="skelton-tiles" count="1" [theme]="{ 
    'border-radius': '0px',
    height: '100px','margin-top':'20px'
  }"></ngx-skeleton-loader>
</div>
<div *ngIf="isDataLoadedUser">
    <app-table [isDataLoaded]="isDataLoadedUser" [tableData]="POS" [tableInfo]="tableInfo"
        [noItemsAvailable]="noItemsAvailable" [tableConfig]="tableConfig" [tableAction]="tableAction"
        [filterClickHeight]="39" [filterNotClickHeight]="57" (onEditClick)="onPOSEditClicked($event)"
        (onDeleteClick)="open_deleteItemModal($event)" [filterSearchAvailability]="filterSearchAvailability"
        [filterAvailability]="filterAvailability" [isFilterClicked]="isFilterClicked" [policies]="[12]"
        (searchItems)="searchItems($event)" [placeholderText]="placeholderText" (getMoreItems)="getMorePages($event)" [currentPage]="currentPage"
        [pages]="pages" [visiblePages]="visiblePages"></app-table>
</div>

<!-- Modal -->
<div class="modal fade" id="posModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="border-radius: 16px !important;">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            POS Integration
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer; " class="d-inline-block align-top" alt="" loading="lazy"
                        data-dismiss="modal" (click)="onCancelPOSModal()">
                </div>
                <hr>
                <form [formGroup]="posForm">

                    <div [ngClass]="!fromaddPOS ? 'displayShopData' : 'hideShopData'">
                        <div>
                            <div style="font-size: 14px;  margin-top: 25px;">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">Franchise</label><span
                                        style="color: #DC4A4A;">*</span>
                                    <input type="text" style=" font-size: 14px;" class="form-control input" disabled
                                        formControlName="franchiseName" aria-describedby="emailHelp">
                                </div>
                            </div>
                        </div>

                        <div>
                            <div style="font-size: 14px;  margin-top: 25px;">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">Outlet</label><span style="color: #DC4A4A;">*</span>
                                    <input type="text" style=" font-size: 14px;" class="form-control input" disabled
                                        formControlName="outletName" aria-describedby="emailHelp">
                                </div>
                            </div>
                        </div>

                    </div>

                    <div [ngClass]="fromaddPOS ? 'displayShopData' : 'hideShopData'">
                        <div class="input-twin">
                            <div class="input-full">
                                <div class="form-group">
                                    <label for="exampleInputEmail1" class="lblInput">Franchise</label><span
                                        style="color: red;">*</span>
                                    <select class='form-control bulkInput selectpicker' id="spicker_franchise_pos2"
                                        formControlName="franchise_id" data-style="dropdownCustomStyle"
                                        (ngModelChange)="selectFranchise($event)" data-live-search="true">
                                        <option *ngFor="let franchise of franchises" [ngValue]="franchise.id">
                                            {{franchise.name}} </option>
                                    </select>
                                </div>
                            </div>
                        </div>


                        <div class="input-twin">
                            <div class="input-full">
                                <div class="form-group">
                                    <label for="exampleInputEmail1" class="lblInput">Outlet</label><span
                                        style="color: red;">*</span>
                                    <select class='form-control bulkInput selectpicker' id="spicker_shop_pos2"
                                        (ngModelChange)="selectShop($event)" formControlName="shop_id"
                                        data-style="dropdownCustomStyle" data-live-search="true" disabled>
                                        <option *ngFor="let shop of shops" [ngValue]="shop.id">
                                            {{shop.name}} </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div style="font-size: 14px;">
                            <div class="form-group">
                                <label for="exampleInputEmail1">POS Type</label><span style="color: #DC4A4A;">*</span>
                                <select (change)="onTypeChangePOS($event.target.value)"
                                    class="custom-select mr-sm-2 input" style="width: 100%; font-size: 14px;"
                                    id="inlineFormCustomSelectPOS" formControlName="type">
                                    <option value='' selected>Choose...</option>
                                    <option *ngFor="let posType of posTypes; let i = index" value={{posType.id}}>
                                        {{posType.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div formGroupName="parameters" *ngIf="isPOSTypeSelected">
                        <div *ngFor="let pos_para of posFeild">
                            <div style="font-size: 14px;">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">{{pos_para}}</label>
                                    <input type="email" style="height: 52px; font-size: 14px;"
                                        class="form-control input" formControlName={{pos_para}}
                                        aria-describedby="emailHelp" placeholder='{{pos_para}} here'>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div>
                        <div style="font-size: 14px;  margin-top: 25px;">
                            <div class="form-group">
                                <label for="exampleInputEmail1">Status</label><span style="color: #DC4A4A;">*</span>
                                <select (change)="onStatusChange($event.target.value)" class="custom-select mr-sm-2"
                                    formControlName="status" style=" font-size: 14px;" id="inlineFormCustomSelectPOS2">
                                    <option value='' selected>Choose...</option>
                                    <option>Active</option>
                                    <option>Inactive</option>
                                </select>
                            </div>
                        </div>
                    </div>

                </form>

                <p *ngIf="isPOSFormInvalid" style="font-size: 14px;" class="alert alert-danger">
                    Please fill the required fields!
                </p>

                <p *ngIf="message != ''  && !posSucess" class="alert alert-danger">{{message}}</p>
                <p *ngIf="message != ''  &&  posSucess" class="alert alert-success">{{message}}</p>

                <div style="display: flex; justify-content: space-between; margin : 25px 0px">
                    <div (click)="onCancelPOSModal()" class="btn-cancel"
                        style=" display: flex; justify-content: center; align-items: center; cursor: pointer;">
                        Cancel
                    </div>

                    <div (click)="fromaddPOS ? addPOS() : editPOS()" style="color:white; display: flex; justify-content: center; align-items: center; width: 180px; height: 42px; background-color:  #2D5697; 
                        border-radius: 5px; cursor: pointer;   font-weight: 400; font-size: 14px !important;">

                        <span *ngIf="!loaderSpinPos"> Save POS Integration</span>
                        <div *ngIf="loaderSpinPos" style="position: absolute;">
                            <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<app-delete-modal modelId="{{modelId}}" modalName="POS Integration" title={{selectedPOSName}}
    (deleteItem)="deleteOutlet()" [loading]="loaderSpinPos"></app-delete-modal>